interface SentryScope {
  setUser: (user: object) => void;
  setTag: (tagName: string, tagValue: number) => void;
}

export const setSentryIdentity = (id: number): void => {
  window.Sentry.configureScope((scope: SentryScope) => scope.setUser({ id }));
};

export const setSentrySiteIdTag = (siteId: number): void => {
  window.Sentry.configureScope((scope: SentryScope) => {
    scope.setTag('site_id', siteId);
  });
};
